import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png'; // Import logo
import facebookLogo from '../assets/facebook-logo.png'; // Import Facebook logo
import './Branch1.css'; // Import styles for Branch1
import Footer from './Footer'; // Import Footer komponenty

const Branch1 = () => {
  const [menu, setMenu] = useState([]);
  const [note, setNote] = useState(''); // State pro poznámku
  const [week, setWeek] = useState('current'); // State to track the selected week (current or next)

  // Načti menu a poznámku při načtení komponenty
  useEffect(() => {
    fetchMenu();
    fetchNote(); // Načtení poznámky
  }, [week]); // Re-fetch menu whenever the week changes

  const fetchMenu = async () => {
    try {
      const response = await fetch(week === 'current' ? '/menu.php' : '/menu1.json'); // Load either current or next week's menu
      const data = await response.json();
      setMenu(data); // Nastavení načteného menu do stavu
    } catch (error) {
      console.error('Chyba při načítání menu:', error);
    }
  };

  const fetchNote = async () => {
    try {
      const response = await fetch('/fetchNoteChot.php'); // Volání PHP skriptu pro načtení poznámky
      const data = await response.json();
      setNote(data.note); // Nastavení poznámky do stavu
    } catch (error) {
      console.error('Chyba při načítání poznámky:', error);
    }
  };

  const getCurrentDate = () => {
    const current = new Date();
    const day = current.getDate();
    const month = current.toLocaleDateString('cs-CZ', { month: 'long' });
    const dayOfWeek = current.toLocaleDateString('cs-CZ', { weekday: 'long' });
    return `${day}. ${month}, ${dayOfWeek}`;
  };

  // Function to get week range, based on whether it's the current or next week
  const getCurrentWeekDates = () => {
    const current = new Date();

    // Adjust to next week if "Příští týden" is selected
    if (week === 'next') {
      current.setDate(current.getDate() + 7); // Move to next week
    }

    // Calculate the start and end dates of the week (Monday to Friday)
    const first = current.getDate() - current.getDay() + 1; // Monday
    const last = first + 4; // Friday

    const firstDay = new Date(current.setDate(first)).toLocaleDateString('cs-CZ');
    const lastDay = new Date(current.setDate(last)).toLocaleDateString('cs-CZ');

    return `${firstDay} - ${lastDay}`;
  };

  return (
    <div className="branch2 min-h-screen flex flex-col">
      {/* Header sekce s logem */}
      <header className="branch2-header h-[20vh] flex items-center justify-center">
        <Link to="/" className="branch2-logo-link">
          <img src={logo} alt="Pizzeria Logo" className="branch2-logo max-w-full h-auto" />
        </Link>
      </header>

      {/* Titulek */}
      <div className="branch2-title-container text-center mt-4">
        <h1 className="branch2-title text-3xl font-bold text-black-700">Chotěšov MenuPoint</h1>

        {/* Zobrazení poznámky, pokud existuje */}
        {note && (
          <div className="branch2-note bg-yellow-100 text-yellow-700 p-4 mt-4">
            <p>{note}</p>
          </div>
        )}
      </div>

      <main className="branch1-content flex flex-col">
        <div className="branch1-column">
          <h2>Zajišťujeme rozvoz poledního menu po Chotěšově a blízkém okolí.</h2><br />
          <h2>Rezervace obědového menu možná vždy do dvanácti hodin předchozího dne.</h2><br />
          <h2>Adresa</h2>
          <a href="https://maps.google.com/?q=Plzeňská 211, Chotěšov" target="_blank" rel="noopener noreferrer">
            Plzeňská 211, Chotěšov
          </a>
          <h2>Telefon</h2>
          <a href="tel:+420730899466">+420 730 899 466</a>
          <h2>Otvírací doba</h2>
          <p>Po-Pá: 10:00 - 14:00</p>
          <a href="https://www.facebook.com/pizzapoint.holysov" target="_blank" rel="noopener noreferrer">
            <img src={facebookLogo} alt="Facebook" className="facebook-logo" />
          </a>

          {/* Buttons to switch between current and next week's menu */}
          <div className="branch1-menu-buttons text-center mt-4">
            <button 
              className={`branch1-menu-btn ${week === 'current' ? 'active' : ''}`} 
              onClick={() => setWeek('current')}
            >
              Tento týden
            </button>
            <button 
              className={`branch1-menu-btn ${week === 'next' ? 'active' : ''}`} 
              onClick={() => setWeek('next')}
            >
              Příští týden
            </button>
          </div>

          <div className="branch1-weekly-menu-header">
            <h2>Polední menu pro týden {getCurrentWeekDates()}</h2>
            <h2>Dnes je {getCurrentDate()}</h2>
            <div className="branch1-weekly-menu-content">
              {menu.length > 0 ? (
                menu.map((item, index) => (
                  <div key={index} className="menu-item">
                    {item.header ? (
                      <h3>{item.name}</h3>
                    ) : item.note ? (
                      <p className="note-item">{item.content}</p> // Note centered and red
                    ) : (
                      <ul>
                        <li>
                          <span>{item.name}</span>
                        </li>
                      </ul>
                    )}
                  </div>
                ))
              ) : (
                <p>Menu zatím není k dispozici.</p>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Branch1;